
import { Popover } from 'antd';
import { getContactDashboard } from 'modules/Analytics/Contacts/action';
import { openEditContactSidePanelAction } from 'modules/Audience/Actions/globalContanctsActions';
import { getContactDetails } from 'modules/Campaigns/Audience/actions';
import { openDetailProfile } from 'modules/GlobalActions';
import React, { useState } from 'react';

type Props = {
  children: object,
  contactId: number;
} & typeof defaultProps;

const defaultProps = {
};
const ContactCardPopover = function ContactCardPopover(props: Props) {
  const { children, contactId } = props;
  const [open, setOpen] = useState(false);

  const handleClick = (e: any) => {
    e.stopPropagation();
    console.log('handleClick: ', open)
    if (!open) {
      setOpen(true);
    }
  };

  const handleDetailsClick = (e: any) => {
    e.stopPropagation();
    console.log('handleDetailsClick: ', open, contactId);
    // contactId && getContactDetails(contactId);
    openDetailProfile();
    getContactDetails(contactId?.toString());
    getContactDashboard(contactId);
    setOpen(false);
  };

  const handleEditClick = (e: any) => {
    e.stopPropagation();
    getContactDetails(contactId?.toString());
    openEditContactSidePanelAction();
    setOpen(false);
  };

  const handleCloseMenu = () => {
    setOpen(!open);
  };

  const UserPopoverTitle = (
    <div className="" onClick={handleDetailsClick}>
      Contact Details
    </div>
  );

  const popoverContent = (
    <div className='edit-text' onClick={handleEditClick}>
      Edit Contact
    </div>
  );


  return (
    <Popover
      placement="leftTop"
      title={UserPopoverTitle}
      content={popoverContent}
      trigger="click"
      overlayClassName='contact-card-popover'
      onClick={handleClick}
      onOpenChange={handleCloseMenu}
      open={open}
    >
      {children}
    </Popover>
  );
};
ContactCardPopover.defaultProps = defaultProps;
export default ContactCardPopover;